import React, {useEffect} from 'react'

import arrayMove from 'array-move'
import {SortableContainer, SortableElement} from 'react-sortable-hoc'
import Photo from './Photo'
import {withOrderFormContext} from '../../../contexts'

const SortablePhoto = SortableElement((item) => <Photo {...item} />)
const SortableGallery = SortableContainer(({items, collectionName}) => {
    return (
        <div className={collectionName?.name || ''}>
            <div className="container">
                {items.map((value, index) => (
                    <SortablePhoto key={`item-${index}`} index={index} photo={value} number={index}/>
                ))}
            </div>
        </div>
    )
})

const PhotoBoardType = ({images, layouts, setLayouts, frameSize, getQuantitySetFromFrameSize}) => {

    const quantityLimit = getQuantitySetFromFrameSize(frameSize)

    useEffect(() => {
        setLayouts(images.slice(0, quantityLimit).map(({thumbnail}) => {
            return {
                src: thumbnail.getPublicUrl()
            }
        }))
    }, [images, setLayouts, quantityLimit])

    const onSortEnd = ({oldIndex, newIndex}) => {
        setLayouts(arrayMove(layouts, oldIndex, newIndex));
    }

    return (
        <div>
            {0 === layouts.length && (
                <div>Please upload 6 photos and change the photo position in the collection by dragging and dropping them in this section.</div>
            )}

            { layouts.length > 0 && (
                <SortableGallery collectionName={frameSize} items={layouts} onSortEnd={onSortEnd} axis={"xy"}/>
            )}
        </div>
    )
}

export default withOrderFormContext(context => ({
    images: context.images,
    layouts: context.layouts,
    setLayouts: context.setLayouts,
    frameSize: context.frameSize,
    getQuantitySetFromFrameSize: context.getQuantitySetFromFrameSize
}))(PhotoBoardType)
